import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../../helpers";
import { OmitStrict } from "../../utils";
import { DesignElementBase, DesignElementGroupableRequiredPart, DesignElementSlugPart } from "./base";
import { DocumentationPageDataV1, ElementGroupDataV1 } from "./data";
import { ElementGroup } from "./group";

//
// Documentation page
//

export const DocumentationPageV1 = DesignElementBase.extend(DesignElementGroupableRequiredPart.shape)
  .extend(DesignElementSlugPart.shape)
  .extend({
    shortPersistentId: z.string(),
    data: DocumentationPageDataV1,
  });

export type DocumentationPageV1 = z.infer<typeof DocumentationPageV1>;

export type CreateDocumentationPageV1 = DbCreateInputOmit<DocumentationPageV1>;
export type UpdateDocumentationPageV1 = OmitStrict<DbUpdate<DocumentationPageV1>, "designSystemVersionId">;

//
// Documentation group (legacy)
//

export const DocumentationGroupV1 = ElementGroup.omit({
  data: true,
}).extend({
  data: ElementGroupDataV1.optional(),
});

export type DocumentationGroupV1 = z.infer<typeof DocumentationGroupV1>;
